export default async (axios, searchValue, page, limit, params = {}) => {
    const response = await axios.post('/Person/GetPersonListing', {
        document: '',
        groupIds: [],
        description: '',
        pageSize: limit,
        pageIndex: page,
        orderBy: ['name', 'asc'],
        name: searchValue || '',
    });

    const { data } = response;

    return {
        metadata: {
            page: data.pageIndex,
            pages: Math.ceil(data.total / data.pageSize),
        },
        result: data.resultList.map(item => ({
            label: item.name,
            key: item.personId,
            item,
        })),
    };
};
